import { useMemo } from "react";

export function useWorkLogHistoryResources(workLogId: string) {
  return useMemo(
    () => [
      {
        resourceType: "WorkLog",
        resourceId: workLogId
      }
    ],
    [workLogId]
  );
}
